<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="titlepage" epub:type="titlepage">
<figure class="tit" id="tit"><img alt="Mrs. Big by Maryann Reid" class="img90" src="images/title.jpg"/></figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3f57f305